export const getCaptionFromPictureMeta = ({title, width, height, year}) => {
    const parts = [
        [title, title],
        [width && height, `${width}×${height}`],
        [year, year]
    ];

    return parts
        .map(([cond, output]) => cond ? output : null)
        .filter(Boolean)
        .join(' - ');
};

export const getArtPiecesFromQueryResult = (data) => {
    const nodes = data.allContentfulPiece.edges.map(edge => edge.node);
    const images = nodes.map(node => node.picture);
    const meta = nodes.map(node => ({
        width: node.width,
        height: node.height,
        title: node.title,
        year: node.year,
    }));

    return {images, meta};
}

export const mod = (n, m) => ((n % m) + m) % m;
